module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC45OSIgaGVpZ2h0PSI0LjM5MSIgdmlld0JveD0iMCAwIDE0Ljk5IDQuMzkxIj4KICA8cGF0aCBpZD0iaWNvX21pbnVzIiBkPSJNLTMuNTMxLTYuMTA5Vi0xMC41aDE0Ljk5djQuMzkxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy41MzEgMTAuNSkiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ico_minus.svg
// module id = RA3I
// module chunks = 2